interface Props {
    text: string;
    color: string;
}

export default function ColouredText({ text, color }: Props) {
    // const buffer = <div className="bg-purple-50 bg-green-50 bg-blue-50 border-purple-400 border-blue-400 border-green-400"></div>;
    return (
        <div className={`p-3 my-2 bg-${color}-50 border-l-4 border-${color}-400`}>
            <p className="text-gray-700" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
}